import React from "react";
import { Modal } from "react-bootstrap";
import CloseButton from "react-bootstrap/CloseButton";
import "./style.scss";
import CommonButton from "../../commonButton";

const ClearTaskModal = ({ show, onHide, onClear }) => {
  return (
    <Modal show={show} centered onHide={onHide} className="sm-modal">
      <Modal.Header className="rename-modal-header">
        <div className="form-modal">
          <Modal.Title>Clear Elements?</Modal.Title>
        </div>
        <CloseButton onClick={onHide} className="close-cta-wrapper" />
      </Modal.Header>
      <Modal.Body className="clear-modal-wrapper">
        <p>
          Are you sure you want to clear all the elements on this page? This
          action cannot be undone.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <CommonButton
          onClick={onHide}
          variant="secondary"
          btnText="No, Cancel"
        />
        <CommonButton
          onClick={onClear}
          variant="primary"
          btnText="Yes, Clear Elements"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default ClearTaskModal;
